<template>
  <!-- The birth component's modal shell: a bottom sheet with a handle on a
       phone, a centred modal on a desktop (design 2026-10-26). Escape and a
       tap on the dim close it. -->
  <Teleport to="body">
    <div class="bs-ov" data-testid="birth-sheet" @click.self="$emit('close')">
      <div class="bs" role="dialog" aria-modal="true" :aria-label="label">
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { onBeforeUnmount, onMounted } from 'vue'

defineProps({ label: { type: String, default: '' } })
const emit = defineEmits(['close'])

// The explainer above it takes Escape first (it stops the event).
function onKey (e) { if (e.key === 'Escape' && !e.defaultPrevented) emit('close') }
onMounted(() => window.addEventListener('keydown', onKey))
onBeforeUnmount(() => window.removeEventListener('keydown', onKey))
</script>

<style scoped>
.bs-ov { position: fixed; inset: 0; z-index: 1360; background: rgba(6, 0, 14, 0.78); backdrop-filter: blur(3px);
  display: flex; align-items: center; justify-content: center; padding: 16px 12px; overflow-y: auto;
  animation: bsFade 0.25s ease both; }
.bs { --bm-bg: #14071f; --bm-line: rgba(240, 217, 163, 0.22); width: 100%; max-width: 500px; max-height: calc(100vh - 32px);
  overflow-y: auto; background: var(--bm-bg); border: 1px solid var(--bm-line); border-radius: 20px;
  padding: 22px 24px 26px; box-shadow: 0 26px 60px -16px rgba(0, 0, 0, 0.85); box-sizing: border-box;
  animation: bsPop 0.3s ease both; }
@keyframes bsFade { from { opacity: 0 } to { opacity: 1 } }
@keyframes bsPop { from { transform: scale(0.97); opacity: 0 } to { transform: none; opacity: 1 } }
@keyframes bsUp { from { transform: translateY(40px); opacity: 0 } to { transform: none; opacity: 1 } }
@media (max-width: 600px) {
  .bs-ov { align-items: flex-end; padding: 0; }
  .bs { max-width: none; max-height: 92vh; border-bottom: 0; border-radius: 22px 22px 0 0; padding: 8px 18px 26px;
    padding-bottom: calc(26px + env(safe-area-inset-bottom, 0px)); box-shadow: 0 -20px 60px rgba(0, 0, 0, 0.6);
    animation-name: bsUp; animation-duration: 0.35s; animation-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1); }
  .bs::before { content: ''; display: block; width: 40px; height: 4px; border-radius: 4px; background: rgba(195, 169, 255, 0.35);
    margin: 2px auto 10px; }
}
@media (prefers-reduced-motion: reduce) {
  .bs-ov, .bs { animation: none; }
}
</style>
